import { useNavigate, useParams } from 'react-router-dom';

import ReferralForm from '@/forms/ReferralForm';
import Container from '@/ui/components/Container';

const EditReferral = () => {
  const navigate = useNavigate();
  const { referralId } = useParams();

  const onSuccess = () => navigate(-1);

  if (!referralId) return null;

  return (
    <Container type="page">
      <ReferralForm referralId={referralId} onSuccess={onSuccess} />
    </Container>
  );
};

export default EditReferral;
